<template>
	<div class="cnews">
		<div class="container">
			<div class="cnewscontain">
				<ul>
					<li 
						v-for="(item,index) in newsData" 
						@click="gotoDetail(item.nid)">
						<img :src="item.img"/>
						<h3>{{item.title}}</h3>
						<p>{{item.summary}}</p>
					</li>
				</ul>
			</div>
			
		</div>
		
	</div>
</template>

<script>
	export default{
		name:'',
		components:{},
		data(){
			return{
				msg:'cnews',
				newsData:[]
			}
		},
		methods:{
			gotoDetail(id){
				this.$router.push({
				          	path: '/NewDetail',
				          	query: {
				          		id:	 id,         
				          	}
				      	})
			},
			getList(id){
				this.axios({
					method: 'get',
					url: this.GLOBAL.newsListApi+id,
					data: {}
				})
				.then((res) => {
					this.newsData = res.data.data;
				})
				.catch((err) => {
					console.log(err)
				})
			}
		},
		created(){
			
		}
		
	}
</script>

<style lang="less" scoped="scoped">
@import url("../../../../styles/main.less");
.cnews{
	.margin-left(10);
	.margin-right(10);
	.margin-bottom(40);
	.cnewscontain{
		ul{
				display: flex;
				flex-wrap: wrap;
				justify-content: space-between;
			li{
				cursor:pointer;
				display: inline-block;
				width: 31%;
				height: 100%;
				img{
					width: 100%;
				}
				h3{
					.margin-top(15);
					.margin-bottom(15);
					white-space:nowrap;
					text-overflow:ellipsis;
					.font-size(30);
					color: #116ebc;
					width: 100%;
					overflow: hidden;
				}
				p{
					.font-size(24);
					width: 100%;
					display: -webkit-box;
					/* -webkit-box-orient: vertical; */
					/*! autoprefixer: off */
					-webkit-box-orient: vertical;
					/* autoprefixer: on */
					-webkit-line-clamp: 2;
					overflow: hidden;
				}
			}
		}
	}
	
}
</style>


// WEBPACK FOOTER //
// src/components/pages/Index/Icom/news.vue